import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { storedProcedure } from "../../utils/storedProceduresConfig";
import HTTPRequest from "../shared-components/HTTPRequest";
import DetailsSummary from "./confirmation-components/DetailsSummary";
import OrderMessage from "./confirmation-components/OrderMessage";
import OrderSummary from "./confirmation-components/OrderSummary";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { confirmOrder } from "../../utils/storedProcedures.js";
import { summariseOrder } from "../../utils/order";
import getUrlParams from "../../utils/getUrlParams";
import ConfirmOrdersSentMessage from "./confirm-order-components/ConfirmOrdersSentMessage";
import { useSearchParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const ConfimOrders = (props) => {
	const [creditCard, setCreditCard] = useState(false);
	const [novat, setNovat] = useState(false);
	const [notes, setNotes] = useState("");
	const [confirmOrderModal, setConfirmOrderModal] = useState({
		open: false,
		message: "",
		success: true,
	});
	const [searchParams, setSearchParams] = useSearchParams();
	const [orgType, setOrgType] = useState({});

	useEffect(() => {
		orgType === "International" ? setNovat(true) : setNovat(false);
	}, [orgType]);

	const handleChange = (name) => (event) => {
		if (event.target.type === "checkbox") {
			name(event.target.checked);
		} else {
			name(event.target.value);
		}
	};

	const getOrder = () => {
		let url = searchParams.toString();
		// this is a call to the stored proceedure wrapped in a promise
		const hash = getUrlHash(url);
		return storedProcedure.getCompletedOrder.requestObject(hash);
	};

	const getUrlHash = (location) => {
		const url = location;
		const hashParamIdentifier = "s=";
		// find the start of the hash param and start after the '=' sign
		const startOfHash = url.indexOf(hashParamIdentifier) + hashParamIdentifier.length;
		const urlMD5Hash = url.slice(startOfHash, url.length);
		return urlMD5Hash;
	};

	const getOrderBasket = (order, packageCatalog) => {
		// packageArray and additionalUserArray are returned as comma seporated values but
		// they need to be converted into an array
		const { ArrayProducts = "", quantArray = "", packageQuantityArray = "" } = order;
		const additionalUserArray = quantArray.split(",");

		/*
		 * NB: for older orders where packageQuantityArray will be null,
		 * use the length of the ArrayProducts and return 1 for each time there is a
		 * packacge item.
		 */
		let packageQuantityArrayValues;
		if (packageQuantityArray === null) {
			const emptyArray = new Array(quantArray.length);
			packageQuantityArrayValues = emptyArray.map(() => 1);
		} else {
			packageQuantityArrayValues = packageQuantityArray.split(",");
		}

		// convert the productID string ie("PK_TB_153") to a productID ie(153)
		const convertProductIDToPackageID = (productIDs) => {
			if (productIDs.length > 0) {
				return productIDs.map((packageItem) => {
					if (typeof packageItem === "string") {
						const startOfPackageID = packageItem.lastIndexOf("_") + 1;
						const packageID = packageItem.substring(startOfPackageID);
						return Number(packageID);
					} else {
						return packageItem;
					}
				});
			} else {
				return productIDs;
			}
		};

		const purchasedPackagesArray = convertProductIDToPackageID(ArrayProducts.split(","));
		// first map over the packages the user has purchaed to put them into the getOrderBasket
		// then map over the list of packages DS sells to fill in the missing DetailsSummary
		// return the populated basket

		const formattedPackages = purchasedPackagesArray.map((item, index) => {
			return {
				packageID: item,
				additionalUsers: additionalUserArray[index],
				packageQuantity: packageQuantityArrayValues[index],
			};
		});

		const basket = formattedPackages.map((item) => {
			const result = packageCatalog.find((product) => {
				if (product.packageID === item.packageID) {
					product.additionalUsers = Number(item.additionalUsers);
					product.packageQuantity = Number(item.packageQuantity);
					return product;
				}
				return null;
			});
			return result;
		});

		return basket;
	};

	const confirmOrderAgain = async (basket, orgDetails) => {
		const userkey = getUrlParams().uk || "";
		const { vat: vattotal, subtotal } = summariseOrder(basket);
		const {
			schoolOrder: schoolorder,
			fullname: contact,
			job: position,
			telephone,
			email: despatchemail,
			financeemail: finance,
			vat: vatnumber,
			dfes: DFES,
			org,
			mailingAddress: address,
			datemade: orderdate,
			promo_source: source,
			promo_code: promo,
			recnum: weborder,
		} = orgDetails;

		const convertedBasket = basket.map((item) => {
			return {
				packageid: item.productID,
				packageprice: item.price,
				extrauserprice: item.extrauserprice,
				extrausercount: item.additionalUsers.toString(),
				additionalpackage: "0",
				packagenumber: item.packageID.toString(),
				pricetype: "",
				packageQuantity: item.packageQuantity.toString(),
				vat: item.vatApplicable,
			};
		});

		const ordertheseJSON = JSON.stringify(convertedBasket);

		const order = {
			DFES,
			org,
			address,
			schoolorder,
			vatnumber,
			contact,
			finance,
			telephone,
			position,
			despatchemail,
			orderdate,
			source,
			promo,
			ordertheseJSON,
			vatpercent: 0,
			subtotal,
			vattotal,
			userkey,
			changedby: "",
			orderkey: "",
			discount: 0,
			weborder,
			novat: novat ? 1 : 0,
			cc: creditCard ? 1 : 0,
			notes,
		};
		const result = await confirmOrder(order);
		if (result.status === 200) {
			const message = "The order has successfully been confirmed, you may now close this tab!";

			setConfirmOrderModal({ open: true, message, success: true });
		} else {
			const message = `Ah there seems to have been an error when confirming this order. Please let a member of the Dev team know about this!
        Error Status: ${result.status}.
        Error Message: ${result.data}
        `;
			setConfirmOrderModal({ open: true, message, success: true });
			console.log("There was an error.");
			console.log(result.status);
		}
	};

	const { packages } = props;

	const DiscountCodeMessage = ({ code }) => (
		<p>
			Discount code: <b>{code}</b>
		</p>
	);
	return (
		<HTTPRequest
			url={storedProcedure.getCompletedOrder.url}
			requestObject={getOrder()}
			setPackages={props.setPackages}
			loadingComponent={() => (
				<div xs={12} style={{ textAlign: "center" }}>
					<br />
					<div />
					<h1>Just getting your order...</h1>
				</div>
			)}
		>
			{(result) => {
				const { recnum, financeemail, org: centreName, promo_code: discountCode } = result[0];
				const basketItems = getOrderBasket(result[0], packages);
				setOrgType(result[0].Type);
				return result.length === 0 ? (
					<div> ah no results</div>
				) : (
					<Container fluid style={{ padding: 30 }}>
						<Row>
							<Col xs={12} sm={6}>
								<h1 style={{ color: "#412878", marginTop: "0px" }}>Thank you {centreName}!</h1>
								<DetailsSummary schoolDetails={result[0]} />
								<br />
								<DiscountCodeMessage className="promo-code__message" code={discountCode} />
								<Form>
									<Form.Check
										type={"checkbox"}
										checked={novat}
										onChange={handleChange(setNovat)}
										value="checkedA"
										label={"No VAT"}
									/>
									<Form.Check
										type={"checkbox"}
										checked={creditCard}
										onChange={handleChange(setCreditCard)}
										value="checkedA"
										label={"Credit Card"}
									/>
								</Form>
								<Form.Label>Notes</Form.Label>
								<Form.Control
									id="notes"
									onChange={handleChange(setNotes)}
									margin="normal"
									variant="outline"
								/>
							</Col>
							<Col xs={12} sm={6}>
								<OrderMessage recnum={recnum} financeemail={financeemail} />
								<OrderSummary basket={basketItems} />
								{props.paperPackage ? (
									<p>
										<strong>
											Please note: a Complete Primary Package subscription is required to order
											printed tests.
										</strong>
										<br />
										Please ensure you have renewed your current subscription before purchase.
									</p>
								) : (
									""
								)}
								<Button
									variant="success"
									onClick={() => confirmOrderAgain(basketItems, result[0])}
									className="confirm-order__btn"
								>
									Confirm Order
								</Button>
							</Col>
						</Row>
						<ConfirmOrdersSentMessage
							open={confirmOrderModal.open}
							message={confirmOrderModal.message}
							success={confirmOrderModal.success}
						/>
					</Container>
				);
			}}
		</HTTPRequest>
	);
};

ConfimOrders.propTypes = {
	location: PropTypes.object,
	history: PropTypes.object,
	packages: PropTypes.array,
	site: PropTypes.object,
};

export default ConfimOrders;
